import { render, staticRenderFns } from "./ResourceDetailModalView.vue?vue&type=template&id=0d69fdac"
import script from "./ResourceDetailModalView.ts?vue&type=script&lang=ts&external"
export * from "./ResourceDetailModalView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports